import React, { useState } from "react";
import SocialPopup from "../Home/SocialPopup";

const certificateData = [
  { id: "cert1", label: "Python Certificate", icon: "🐍" },
  { id: "cert2", label: "Gen AI Certificate", icon: "🤖" },
  { id: "cert3", label: "SQL Certificate", icon: "🗄️" },
  { id: "cert4", label: "GDSC Certificate", icon: "🌐" },
  { id: "cert5", label: "HTML/CSS/JS for Web Dev", icon: "🌍" },
  { id: "cert6", label: "Bit Degree Certificate", icon: "🎓" },
  { id: "cert7", label: "Data Science with Django", icon: "📊" },
  { id: "cert8", label: "AWS Certificate", icon: "☁️" },
  { id: "cert9", label: "BIT MESRA Certificate", icon: "🏛️" },
  { id: "cert10", label: "WordPress Certificate", icon: "📝" },
];

function Certifications() {
  const [hoveredCert, setHoveredCert] = useState(null);

  return (
    <section className="cert-section" id="certifications">
      <div className="cert-bg" aria-hidden="true">
        <div className="cert-orb cert-orb-a" />
        <div className="cert-orb cert-orb-b" />
      </div>

      <div className="cert-inner">
        <div className="cert-header">
          <span className="section-tag">› credentials</span>
          <h2 className="section-heading">
            Certifications<br />
            <em>& Achievements</em>
          </h2>
          <p className="section-sub">
            Industry-recognized certifications that validate my expertise.
          </p>
        </div>

        <div className="cert-grid">
          {certificateData.map((cert) => (
            <div
              key={cert.id}
              className={`cert-card ${hoveredCert === cert.id ? "cert-active" : ""}`}
              onMouseEnter={() => setHoveredCert(cert.id)}
              onMouseLeave={() => setHoveredCert(null)}
            >
              <div className="cert-icon">{cert.icon}</div>
              <div className="cert-label">{cert.label}</div>
              <button className="cert-btn">View</button>
            </div>
          ))}
        </div>

        <div className="cert-cta">
          <p className="cert-cta-title">Let's verify my expertise for your project</p>
          <p className="cert-cta-sub">I'm always happy to discuss how my skills can benefit your business.</p>
          <a
            href="#contacts"
            className="cta-primary"
            onClick={(e) => { e.preventDefault(); document.getElementById("contacts")?.scrollIntoView({ behavior: "smooth" }); }}
          >
            Let's Talk →
          </a>
        </div>

        <div className="cert-social">
          <SocialPopup />
        </div>
      </div>

      <style>{`
        .cert-section {
          position: relative;
          padding: 100px 6vw;
          background: var(--bg);
          min-height: 100vh;
          overflow: hidden;
        }

        .cert-bg {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: 0;
        }
        .cert-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
        }
        .cert-orb-a {
          width: 400px; height: 400px;
          background: radial-gradient(circle, rgba(139,114,255,0.1), transparent 70%);
          top: -80px; right: 5%;
        }
        .cert-orb-b {
          width: 300px; height: 300px;
          background: radial-gradient(circle, rgba(245,201,122,0.08), transparent 70%);
          bottom: 10%; left: 8%;
        }

        .cert-inner {
          position: relative;
          z-index: 10;
          max-width: 1280px;
          margin: 0 auto;
        }

        .cert-header {
          margin-bottom: 50px;
        }

        .cert-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 20px;
          margin-bottom: 60px;
        }

        .cert-card {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 20px 24px;
          background: var(--surface);
          border: 1px solid var(--border);
          border-radius: 12px;
          transition: all 0.3s ease;
        }
        .cert-card:hover {
          border-color: var(--accent);
          transform: translateY(-3px);
        }
        .cert-active .cert-icon {
          transform: scale(1.1);
        }

        .cert-icon {
          font-size: 1.8rem;
          transition: transform 0.3s ease;
        }

        .cert-label {
          flex: 1;
          font-family: var(--ff-body);
          font-size: 0.95rem;
          font-weight: 500;
          color: var(--text);
        }

        .cert-btn {
          padding: 8px 16px;
          background: transparent;
          border: 1px solid var(--border-hi);
          border-radius: 6px;
          font-family: var(--ff-mono);
          font-size: 0.75rem;
          color: var(--muted);
          cursor: pointer;
          transition: all 0.25s ease;
        }
        .cert-btn:hover {
          border-color: var(--accent);
          color: var(--accent);
        }

        .cert-cta {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 36px 40px;
          background: var(--surface);
          border: 1px solid var(--border);
          border-radius: 14px;
          flex-wrap: wrap;
          gap: 24px;
          margin-bottom: 50px;
        }
        .cert-cta-title {
          font-family: var(--ff-display);
          font-size: 1.5rem;
          font-weight: 400;
          color: var(--text);
          margin: 0 0 6px;
        }
        .cert-cta-sub {
          font-size: 0.9rem;
          color: var(--muted);
          margin: 0;
        }

        .cert-social {
          text-align: center;
        }

        @media (max-width: 1024px) {
          .cert-grid { grid-template-columns: repeat(2, 1fr); }
        }

        @media (max-width: 680px) {
          .cert-section { padding: 80px 5vw; }
          .cert-grid { grid-template-columns: 1fr; }
          .cert-cta { flex-direction: column; text-align: center; }
        }
      `}</style>
    </section>
  );
}

export default Certifications;